/**
 * SHOPIFY EPIC ACCESSIBILITY & SEO ENGINE
 * ---------------------------------------
 * VERSION: 6.0.0 (Master Production Build)
 * CLIENT: Marek Diagnostics
 * TARGET: WCAG 2.2 Level AA & SEO Optimization
 * NOTE: jQuery dependency assumed per legacy architecture, modularized for speed.
 */

window.ThemeEpic = (function($) {
    'use strict';
    let isProcessing = false;

    // Detect Keyboard vs. Mouse Users for UI Layouts
    $(document).on('keydown', function(e) {
        if (e.key === 'Tab') { $('body').addClass('epic-is-tabbing'); }
    }).on('mousedown', function() {
        $('body').removeClass('epic-is-tabbing');
    });

    /* ==========================================================================
       SECTION 1: GLOBAL CONFIGURATION & DATA MATRICES
       ========================================================================== */
    const epicConfig = {
        // The Global SVG Library (Replacing FontAwesome)
        // All SVGs are pre-sanitized with aria-hidden="true" and focusable="false"
        svgs: {
            external: '<svg class="epic-icon epic-icon-right" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/></svg>',
            pdf: '<svg class="epic-icon epic-icon-right" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H336c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336v96h32zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V352z"/></svg>',
            close: '<svg class="epic-icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>',
            hamburger: '<svg class="epic-icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/></svg>',
            alert: '<svg class="epic-icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.8-20.1s-7.2-27.7 .1-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>',
            info: '<svg class="epic-icon epic-icon-left" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>',
            question: '<svg class="epic-icon epic-icon-left" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-16.7 46.9c-4.5 12.6-18.4 19.3-31 14.8s-19.3-18.4-14.8-31zM256 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>',
            play: '<svg class="epic-icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/></svg>',
            success: '<svg class="epic-icon epic-icon-success" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>',
            error: '<svg class="epic-icon epic-icon-error" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>'
        },
        
       // =====================================================================
        // DATA PAYLOADS & MAPPINGS
        // =====================================================================
        
        // Map graphic filenames to complex HTML data table/list payloads (WCAG 1.1.1)
        textImageContentMap: {
            'marek-dummy-infographic.jpg': {
                'en': '<div class="sr-only">Detailed description or data table for the infographic goes here.</div>',
                'es': '<div class="sr-only">Descripción detallada o tabla de datos para la infografía aquí.</div>'
            }
        },
               
        // WCAG 1.2.2 Captions: Inherits dynamic multi-lingual .vtt paths from theme.liquid
        mediaCaptionMap: (window.EpicThemeConfig && window.EpicThemeConfig.captions) ? window.EpicThemeConfig.captions : {},

        // WCAG 1.2.8 Media Alternative: Map video IDs to localized descriptive HTML text
        mediaTranscriptMap: {
            '0a39a85423a241379ef9c9ca91ff6cf2': {
                'en': '<p>A visual montage representing Marek Diagnostics\' commitment to health and performance. The video features scientists processing vials in a modern laboratory, athletes exercising and stretching outdoors, firefighters suiting up in their station, and microscopic views of human tissue.</p>',
                'es': '<p>Un montaje visual que representa el compromiso de Marek Diagnostics con la salud y el rendimiento. El video muestra a científicos procesando viales en un laboratorio moderno, atletas haciendo ejercicio al aire libre, bomberos equipándose y vistas microscópicas de tejido humano.</p>'
            }
        },
        
        // Constants
        notifyDuration: 8000 // Fallback timer for notifications (8 seconds per WCAG guidelines)
    };
   /* ==========================================================================
       SECTION 1.5: INTERNATIONALIZATION (i18n) DICTIONARY & HELPER
       ========================================================================== */
    const epicStrings = {
        'en': {
            skipMenu: 'Skip to Main Menu',
            skipContent: 'Skip to Content',
            skipFooter: 'Skip to Footer',
            readTranscript: 'Read Descriptive Video Transcript',
            success: 'Success',
            addedToCart: 'added to your cart',
            dismiss: 'Dismiss notification',
            variantUpdated: 'Variant updated to',
            newPrice: 'New price:',
            pauseVideo: 'Pause background video',
            playVideo: 'Play background video',
            increaseQty: 'Increase quantity',
            decreaseQty: 'Decrease quantity',
            gallery: 'Product Media Gallery',
            dialog: 'Dialog Window',
            selectFallback: 'Select Option',
            trackLabel: 'English',
            readReviews: 'Read product reviews. Jump to review section.',
            selectCustomSort: 'Sort by',
           bundleUpdated: 'Bundle updated.',
            items: 'items.',
            total: 'Total:',
            removeFromBundle: 'Remove from bundle:',
            salePrice: 'Sale price:',
            originalPrice: 'Original price:',
            discount: 'Discount:',
            announcements: 'Announcements',
            selectedItems: 'Selected items',
            carousel: 'Scrollable Carousel',
            hlbSearchLabel: 'Search Biomarkers'
        },
        'es': {
            skipMenu: 'Saltar al menú principal',
            skipContent: 'Saltar al contenido',
            skipFooter: 'Saltar al pie de página',
            readTranscript: 'Leer transcripción descriptiva del video',
            success: 'Éxito',
            addedToCart: 'añadido a tu carrito',
            dismiss: 'Descartar notificación',
            variantUpdated: 'Variante actualizada a',
            newPrice: 'Nuevo precio:',
            pauseVideo: 'Pausar video de fondo',
            playVideo: 'Reproducir video de fondo',
            increaseQty: 'Aumentar cantidad',
            decreaseQty: 'Disminuir cantidad',
            gallery: 'Galería de medios del producto',
            dialog: 'Ventana de diálogo',
            selectFallback: 'Seleccionar opción',
            trackLabel: 'Español',
            readReviews: 'Leer reseñas de productos. Saltar a la sección de reseñas.',
            bundleUpdated: 'Paquete actualizado.',
            items: 'artículos.',
            total: 'Total:',
            removeFromBundle: 'Eliminar del paquete:',
            salePrice: 'Precio de oferta:',
            originalPrice: 'Precio original:',
            discount: 'Descuento:',
            announcements: 'Anuncios',
            selectedItems: 'Artículos seleccionados'

        },
        'fr': {
            skipMenu: 'Passer au menu principal',
            skipContent: 'Passer au contenu',
            skipFooter: 'Passer au pied de page',
            readTranscript: 'Lire la transcription descriptive',
            success: 'Succès',
            addedToCart: 'ajouté à votre panier',
            dismiss: 'Ignorer la notification',
            variantUpdated: 'Variante mise à jour à',
            newPrice: 'Nouveau prix :',
            pauseVideo: 'Mettre en pause la vidéo',
            playVideo: 'Lire la vidéo',
            increaseQty: 'Augmenter la quantité',
            decreaseQty: 'Diminuer la quantité',
            gallery: 'Galerie de médias',
            dialog: 'Fenêtre de dialogue',
            selectFallback: 'Sélectionner une option',
            trackLabel: 'Français',
            readReviews: 'Lire les avis sur les produits. Passer à la section des avis.',
            bundleUpdated: 'Forfait mis à jour.',
            items: 'articles.',
            total: 'Total :',
            removeFromBundle: 'Retirer du forfait :',
            salePrice: 'Prix réduit :',
            originalPrice: 'Prix initial :',
            discount: 'Remise :',
            announcements: 'Annonces',
            selectedItems: 'Articles sélectionnés'
        },
        'de': {
            skipMenu: 'Zum Hauptmenü springen',
            skipContent: 'Zum Inhalt springen',
            skipFooter: 'Zum Fußzeile springen',
            readTranscript: 'Deskriptives Videotranskript lesen',
            success: 'Erfolg',
            addedToCart: 'zum Warenkorb hinzugefügt',
            dismiss: 'Benachrichtigung schließen',
            variantUpdated: 'Variante aktualisiert auf',
            newPrice: 'Neuer Preis:',
            pauseVideo: 'Hintergrundvideo pausieren',
            playVideo: 'Hintergrundvideo abspielen',
            increaseQty: 'Menge erhöhen',
            decreaseQty: 'Menge verringern',
            gallery: 'Produktmedien-Galerie',
            dialog: 'Dialogfenster',
            selectFallback: 'Option auswählen',
            trackLabel: 'Deutsch',
            readReviews: 'Produktbewertungen lesen. Zum Bewertungsbereich springen.',
            bundleUpdated: 'Paket aktualisiert.',
            items: 'Artikel.',
            total: 'Gesamt:',
            removeFromBundle: 'Aus dem Paket entfernen:',
            salePrice: 'Angebotspreis:',
            originalPrice: 'Ursprünglicher Preis:',
            discount: 'Rabatt:',
            announcements: 'Ankündigungen',
            selectedItems: 'Ausgewählte Artikel'
        }
    };

    // The universal, blazing-fast translation retriever
    const t = (key) => {
        let lang = ($('html').attr('lang') || 'en').substring(0, 2).toLowerCase();
        if (!epicStrings[lang]) lang = 'en'; 
        return epicStrings[lang][key] || epicStrings['en'][key] || key;
    };

    /* ==========================================================================
       SECTION 2: GLOBAL FOCUS REGISTRY (Active Element Caching)
       ========================================================================== */
    const FocusRegistry = {
        cache: null,
        save: function() {
            this.cache = document.activeElement;
        },
        restore: function() {
            if (this.cache && typeof this.cache.focus === 'function') {
                this.cache.focus();
                this.cache = null; 
            }
        }
    };

    /* ==========================================================================
       SECTION 3: THE APP FOOTPRINT GATEKEEPER
       ========================================================================== */
    const Gatekeeper = {
        hasApp: function(windowObj, domSelector) {
            return (typeof windowObj !== 'undefined') || ($(domSelector).length > 0);
        }
    };

    /* ==========================================================================
       SECTION 4: WCAG 2.2 LEVEL AA MICRO-MODULES
       ========================================================================== */
    const executeMicroModules = () => {
        // 1. Language of Page Enforcement (3.1.1)
        if (!$('html').attr('lang') || $('html').attr('lang').trim() === '') {
            const shopifyLocale = (window.Shopify && window.Shopify.locale) ? window.Shopify.locale : 'en';
            $('html').attr('lang', shopifyLocale);
        }

        // 2. Identify Input Purpose / Autocomplete Hydration (1.3.5)
        $('input[type="email"]:not([autocomplete])').attr('autocomplete', 'email');
        $('input[type="tel"]:not([autocomplete])').attr('autocomplete', 'tel');
        $('input[name*="firstname"], input[name*="first_name"]').not('[autocomplete]').attr('autocomplete', 'given-name');
        $('input[name*="lastname"], input[name*="last_name"]').not('[autocomplete]').attr('autocomplete', 'family-name');

        // 3. Accessible Authentication Paste-Block Stripper (3.3.8)
        // Strictly scoped to ignore financial gateways/CC fields
        $('input[type="password"], input[type="email"], input[autocomplete="new-password"]')
            .not('[name*="cc-number"], [name*="cvv"], [name*="routing"]')
            .each(function() {
                this.onpaste = null;
                this.ondrop = null;
                this.oncopy = null;
                $(this).removeAttr('onpaste ondrop oncopy');
            });

        // 4. Pause, Stop, Hide Autoplay Catcher (2.2.2)
$('video[autoplay]:not([controls])').each(function() {
    const $video = $(this);
    // Modified: Now checks for ANY button in the wrapper to prevent duplication
    if (!$video.parent().find('.epic-pause-btn, button').length) {
                //inline styles - need to be converted to CSS sheet.
                const $pauseBtn = $('<button type="button" class="epic-pause-btn" aria-label="' + t('pauseVideo') + '" style="position:absolute; bottom:10px; right:10px; z-index:99; background: #000; color: #fff; border: none; border-radius: 50%; padding: 10px; cursor: pointer;">' + epicConfig.svgs.play + '</button>');

                $pauseBtn.on('click', function() {
                    if ($video[0].paused) {
                        $video[0].play();
                        $(this).attr('aria-label', t('pauseVideo'));
                    } else {
                        $video[0].pause();
                        $(this).attr('aria-label', t('playVideo'));
                    }
                });
                $video.parent().css('position', 'relative').append($pauseBtn);
            }
        });
    };

    /* ==========================================================================
       SECTION 5: CORE PIPELINE & INITIALIZATION
       ========================================================================== */
    const runCorePipeline = () => {
        executeMicroModules();
        
        /* ==========================================================================
           [PHASE 3: CHUNK 1] CORE SCRUBBING & DOM HYDRATION MODULES
           ========================================================================== */

        // 1. DEEP SCRUBBER (Empty Tags & Deprecated Semantics)
        const deepScrub = () => {
            // WAVE Fix: Ensure all search inputs have an accessible name
            $('input[type="search"], input[name="q"], form[action*="/search"] input[type="text"]').each(function() {
                if (!$(this).attr('aria-label')) {
                    $(this).attr('aria-label', 'Search');
                }
            });

            // WAVE Fix: Silence decorative images missing alt text
            $('img:not([alt])').attr('alt', '');

            // Remove completely empty formatting/heading tags to prevent screen reader "dead air"
            $('p, h1, h2, h3, h4, h5, h6').each(function() {
                const $el = $(this);
                const visibleText = $el.text().replace(/[\s\u00A0\u200B]/g, '');
                const hasAriaName = $el.attr('aria-label') || $el.attr('aria-labelledby');
                const hasMedia = $el.find('img, svg, iframe, video, i, canvas, [class*="icon"]').length > 0;
                
                if (visibleText === "" && !$el.attr('id') && !hasAriaName && !hasMedia) {
                    $el.remove();
                }
            });

            // Neutralize deprecated underline tags (WCAG 1.3.1 Info & Relationships)
            $('u').each(function() {
                $(this).replaceWith('<span style="text-decoration: underline;">' + $(this).html() + '</span>');
            });

            // Axe Fix: Hide 1x1 tracking iFrames from screen readers
            $('iframe[width="1"], iframe[width="0"], iframe[height="1"], iframe[height="0"], iframe[style*="display: none"]').each(function() {
                $(this).attr({
                    'aria-hidden': 'true',
                    'tabindex': '-1'
                });
            });
        };

        // 2. SEO HEADING NORMALIZER (Attribute-Preserving)
        const normalizeHeadings = () => {
            let $primaryH1 = $('h1').first();
            
            if (!$primaryH1.length) {
                let $firstH2 = $('h2').first();
                if ($firstH2.length) { 
                    // Preserve native classes, IDs, and data-attributes to protect theme JS hooks
                    let $newH1 = $('<h1/>').html($firstH2.html());
                    $.each($firstH2[0].attributes, function(i, attr) {
                        $newH1.attr(attr.name, attr.value);
                    });
                    $firstH2.replaceWith($newH1);
                    $primaryH1 = $('h1').first(); 
                }
            }

            let lastLevel = 1;
            $('h1, h2, h3, h4, h5, h6').not('.header__logo').each(function() {
                const $el = $(this);
                if (this.offsetWidth === 0 && this.offsetHeight === 0) return; 
                
                if ($el.is($primaryH1)) {
                    lastLevel = 1;
                    return;
                }

                let cur = parseInt(this.tagName.substring(1)) || parseInt($el.attr('aria-level'));
                if (cur > lastLevel + 1) {
                    $el.attr({ 'role': 'heading', 'aria-level': lastLevel + 1 });
                    lastLevel++;
                } else {
                    lastLevel = cur;
                }
            });

            // WAVE Fix: Mask empty headings from the accessibility tree 
            $('h1, h2, h3, h4, h5, h6').each(function() {
                const $heading = $(this);
                if ($heading.text().trim() === '' && $heading.children().length === 0) {
                    $heading.attr('aria-hidden', 'true');
                } else {
                    $heading.removeAttr('aria-hidden'); // Unmask it if the theme injects text
                }
            });
        };

        // 3. INLINE ENHANCER & EVENT SYNTHESIS (Tooltips, Faux-Buttons, Custom Swatches)
        const hydrateNonInteractiveElements = () => {
            // A. Tooltips & Help Icons
            $('.tooltip, .help-icon, .hint, [data-tooltip]').not('button, a, input, select, textarea').each(function() {
                const $el = $(this);
                if (!$el.attr('tabindex')) {
                    $el.attr({
                        'role': 'button',
                        'tabindex': '0',
                        'aria-expanded': 'false'
                    }).addClass('epic-tooltip-trigger');
                    
                    // Inject Info SVG if it lacks internal iconography
                    if ($el.find('svg, img, i').length === 0) {
                        $el.prepend(epicConfig.svgs.info);
                    }
                }
            });

            // B. Custom Quantity Adjusters (+ / - spans)
            $('[class*="qty-plus"], [class*="qty-minus"], .quantity__button').not('button, a').each(function() {
                const $el = $(this);
                if (!$el.attr('tabindex')) {
                    const ariaLabel = $el.attr('class').includes('plus') ? t('increaseQty') : t('decreaseQty');
                    $el.attr({
                        'role': 'button',
                        'tabindex': '0',
                        'aria-label': ariaLabel
                    });
                }
            });

            // C. Accordion / Filter Toggle Headers
            $('.accordion-toggle, .facets__summary, .filter-group-summary').not('button, a, summary').each(function() {
                const $el = $(this);
                if (!$el.attr('tabindex')) {
                    $el.attr({
                        'role': 'button',
                        'tabindex': '0'
                    });
                    // Sync initial state
                    const isOpen = $el.hasClass('is-active') || $el.hasClass('is-open');
                    $el.attr('aria-expanded', isOpen ? 'true' : 'false');
                }
            });

            /// D. Review Badges (Judge.me, Stamped) that scroll to reviews
            $('.jdgm-badge, .stamped-badge').not('button, a').each(function() {
                const $el = $(this); // BUG FIXED: Added scope definition
                if (!$el.attr('tabindex') && $el.attr('data-id')) {
                    $el.attr({
                        'role': 'button',
                        'tabindex': '0',
                        'aria-label': t('readReviews')
                    });
                }
            });

            // EVENT SYNTHESIS: Map Enter/Space to native click for all hydrated faux-buttons
            $(document).off('keydown.epicHydration').on('keydown.epicHydration', '[role="button"][tabindex="0"]:not(button, a)', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    
                    // Toggle aria-expanded if applicable
                    if ($(this).attr('aria-expanded')) {
                        const newState = $(this).attr('aria-expanded') === 'true' ? 'false' : 'true';
                        $(this).attr('aria-expanded', newState);
                    }
                    
                    // Synthesize click
                    $(this)[0].click();
                }
            });

            // BRUTE FORCE FIX: Catch dynamically rendered SVGs inside Custom Web Components
            // that spawn after the initial page load.
            $('spinning-text svg').attr({
                'aria-hidden': 'true',
                'focusable': 'false'
            })
        };

    // 4. ADVANCED SKIP NAVIGATION ENFORCER
       const initSkipLinks = () => {
            // Guard: If we already injected the nav, stop immediately
            if ($('.epic-skip-nav').length > 0) return; 

            $('.skip-link').remove();

            // Assign ID targets
            const $header = $('header, .header-group, #shopify-section-header').first();
            const menuTarget = $header.attr('id') || 'epic-header-target';
            if (!$header.attr('id')) $header.attr('id', menuTarget);

            const $main = $('main, [role="main"], #MainContent').first();
            const contentTarget = $main.attr('id') || 'epic-main-target';
            if (!$main.attr('id')) $main.attr('id', contentTarget);
            
            const $footer = $('footer, footer-group, .footer-group').first();
            const footerTarget = $footer.attr('id') || 'epic-footer-target';
            if (!$footer.attr('id')) $footer.attr('id', footerTarget);

            const $skipNav = $(`
                <nav class="epic-skip-nav" aria-label="Skip navigation">
                    <a href="#${menuTarget}" class="epic-skip-link">${t('skipMenu')}</a>
                    <a href="#${contentTarget}" class="epic-skip-link">${t('skipContent')}</a>
                    <a href="#${footerTarget}" class="epic-skip-link">${t('skipFooter')}</a>
                </nav>
            `);
            $('body').prepend($skipNav);

            // FIX: Unified handler for Click AND Tab key
            // This handles the jump AND the visual collapse when focus moves
            $(document).on('click keydown', '.epic-skip-link', function(e) {
                // Handle Enter (which is click) and native Tab navigation
                if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
                    e.preventDefault();
                    const targetId = $(this).attr('href');
                    const $target = $(targetId);
                    if ($target.length) {
                        $target.attr('tabindex', '-1').focus();
                    }
                }
                
                // If it's a Tab key, do nothing! 
                // Let the browser's native focus logic move the cursor to the next DOM item.
                // The nav will disappear automatically because of :focus-within.
            });
        };

        // 5. LANDMARK ENFORCER (De-duplication & Assignment)
        const enforceLandmarks = () => {
            // Banner (Header)
            const $headers = $('header, .header-group, #shopify-section-header');
            $headers.first().attr('role', 'banner');
            if ($headers.length > 1) $headers.not(':first').removeAttr('role');

            // Contentinfo (Footer)
            const $footers = $('footer, footer-group');
            $footers.first().attr('role', 'contentinfo');
            if ($footers.length > 1) {
                // AXE FIX: .removeAttr() isn't enough for native <footer> tags. 
                // We must force role="presentation" to strip the native landmark status from duplicates/nested tags.
                $footers.not(':first').attr('role', 'presentation');
            }

            // Main (Content)
            const $mains = $('main, #MainContent, [role="main"]');
            $mains.first().attr('role', 'main');
            if ($mains.length > 1) {
                $mains.not(':first').each(function() {
                    if ($(this).attr('role') === 'main') $(this).removeAttr('role');
                });
            }

            // Complementary (Aside/Sidebar)
            $('aside, .sidebar, .facets-wrapper').each(function() {
                if (!$(this).attr('role')) $(this).attr('role', 'complementary');
            });
            
            // Nested Landmark Stripper (Failsafe against theme spaghetti)
            $('[role="main"] [role="main"], [role="banner"] [role="banner"]').removeAttr('role');

            // NEW: Add semantic region to Announcement Bars so users can find them voluntarily
            $('announcement-bar:not([role])').attr({
                'role': 'region',
                'aria-roledescription': 'carousel',
                'aria-label': t('announcements') || 'Announcements'
            });
        };

       // 6. UNIVERSAL VIDEO COMPLIANCE ROUTER (Multi-Lingual Captions & Transcripts)
        const manageVideoCompliance = () => {
            const currentLang = ($('html').attr('lang') || 'en').substring(0, 2).toLowerCase();

            // A. Inject VTT Captions for informational videos (WCAG 1.2.2)
            if (epicConfig.mediaCaptionMap && Object.keys(epicConfig.mediaCaptionMap).length > 0) {
                $.each(epicConfig.mediaCaptionMap, function(videoId, tracks) {
                    // Added .each() to handle duplicate video embeds on the same page
                    $(`video[src*="${videoId}"], source[src*="${videoId}"]`).closest('video').each(function() {
                        const $video = $(this);
                        
                        if ($video.find('track').length === 0) {
                            $.each(tracks, function(trackLang, vttUrl) {
                                const trackLabel = (epicStrings[trackLang] && epicStrings[trackLang].trackLabel) ? epicStrings[trackLang].trackLabel : trackLang.toUpperCase();
                                const isDefault = (trackLang === currentLang) ? 'default' : '';
                                
                                $video.append(`<track kind="captions" src="${vttUrl}" srclang="${trackLang}" label="${trackLabel}" ${isDefault}>`);
                            });
                            // Rescue instructional videos from screen reader oblivion
                            $video.removeAttr('aria-hidden tabindex'); 
                        }
                    });
                });
            }

            // B. Axe Failsafe: Hide silent/decorative background videos from screen readers
            $('video').each(function() {
                const $vid = $(this);
                // Check both DOM properties AND HTML attributes to catch JS-muted videos
                const isAutoplay = $vid.prop('autoplay') || $vid.attr('autoplay') !== undefined;
                const isMuted = $vid.prop('muted') || $vid.attr('muted') !== undefined;
                
                if (isAutoplay && isMuted && $vid.find('track').length === 0) {
                    $vid.attr({'aria-hidden': 'true', 'tabindex': '-1'});
                }
            });

            // C. Inject Text Transcripts (WCAG 1.2.8) - Responsive Overlay
            if (epicConfig.mediaTranscriptMap && Object.keys(epicConfig.mediaTranscriptMap).length > 0) {
                $.each(epicConfig.mediaTranscriptMap, function(videoId, localizedTranscripts) {
                    // Added .each() to ensure transcripts apply to all instances
                    $(`iframe[src*="${videoId}"], video[data-id="${videoId}"], [data-video-id="${videoId}"], source[src*="${videoId}"]`).closest('video, iframe, video-media').each(function() {
                        const $media = $(this);
                        const $wrapper = $media.parent(); 
                        
                        if ($wrapper.find('.epic-transcript-overlay').length === 0) {
                            const transcriptHtml = localizedTranscripts[currentLang] || localizedTranscripts['en'] || localizedTranscripts[Object.keys(localizedTranscripts)[0]];
                            
                            const $details = $(`
                                <details class="epic-transcript-overlay">
                                    <summary class="epic-transcript-summary" aria-label="${t('readTranscript') || 'Read transcript'}">
                                        ${epicConfig.svgs && epicConfig.svgs.info ? epicConfig.svgs.info : 'ℹ️'}
                                        <span class="epic-summary-text" aria-hidden="true">${t('readTranscript') || 'Read transcript'}</span>
                                    </summary>
                                    <div class="epic-transcript-content">
                                        ${transcriptHtml}
                                    </div>
                                </details>
                            `);
                            
                            if ($wrapper.css('position') === 'static') {
                                $wrapper.css('position', 'relative');
                            }
                            
                            $wrapper.append($details);
                        }
                    });
                });
            }
        };

        // 7. COMPLEX IMAGE DATA INJECTOR (WCAG 1.1.1)
        const manageComplexImages = () => {
            const currentLang = ($('html').attr('lang') || 'en').substring(0, 2).toLowerCase();

            if (epicConfig.textImageContentMap && Object.keys(epicConfig.textImageContentMap).length > 0) {
                $.each(epicConfig.textImageContentMap, function(imgFilename, localizedHtml) {
                    // Hunt for the image by filename
                    const $img = $(`img[src*="${imgFilename}"]`).first();
                    
                    if ($img.length) {
                        const $wrapper = $img.parent();
                        // Prevent duplicate injections
                        if ($wrapper.find('.epic-complex-desc').length === 0) {
                            
                            // Resolve the correct translation or fallback
                            const descHtml = localizedHtml[currentLang] || localizedHtml['en'] || localizedHtml[Object.keys(localizedHtml)[0]];
                            
                            // Inject directly after the image so screen readers hit it immediately
                            $img.after(`<div class="epic-complex-desc">${descHtml}</div>`);
                        }
                    }
                });
            }
        };

        // 8. IMAGE LINK FOCUS ROUTER
        const normalizeImageLinks = () => {
            $('a').each(function() {
                const $a = $(this);
                
                // Check if the link contains an image, SVG, or picture element
                if ($a.find('img, svg, picture').length > 0) {
                    
                    // Clone the link in memory and strip out screen-reader-only text
                    const $clone = $a.clone();
                    $clone.find('[class*="sr-only"], [class*="visually-hidden"]').remove();
                    
                    // If there is no visible text left, it is a pure image/icon link. Route the focus!
                    if ($clone.text().trim().length === 0) {
                        $a.addClass('epic-img-link');
                    }
                }
            });
        };

        // 9. GLOBAL INPUT & VIEWPORT STABILIZER
        const stabilizeGlobalInputs = () => {
            // WCAG 1.4.4 Resize text: Strip anti-zoom tags if the theme uses them
            const $viewport = $('meta[name="viewport"]');
            if ($viewport.length) {
                let content = $viewport.attr('content') || '';
                if (content.includes('maximum-scale=1') || content.includes('user-scalable=no')) {
                    // Reset to a standard, accessible mobile viewport
                    $viewport.attr('content', 'width=device-width, initial-scale=1.0');
                }
            }

            // Provide a fallback ID and ARIA label for raw <select> elements missing context
            let selectCnt = 1;
            $('select:not([aria-label]):not([id])').each(function() {
                $(this).attr({
                    'id': `epic-select-fallback-${selectCnt}`, 
                    'aria-label': `${t('selectFallback')} ${selectCnt}`
                });
                selectCnt++;
            });
        };

        // 10. HOMEPAGE LAB BUILDER SCRUBBER
        const hydrateLabBuilder = () => {
            // A. Contextualize Pricing for BOTH Homepage and Full Page (WCAG 1.3.1)
            $('.hlb-card__price, .hlb-modal__price-row, .lb-card__price').each(function() {
                const $row = $(this);
                if ($row.attr('data-epic-hydrated')) return;
                $row.attr('data-epic-hydrated', 'true');

                const $now = $row.find('.hlb-card__price-now, .hlb-modal__price-now, .lb-card__price-now');
                const $was = $row.find('.hlb-card__price-was, .hlb-modal__price-was, .lb-card__price-was');
                const $save = $row.find('.hlb-card__price-save, .hlb-modal__price-save, .lb-card__price-save');

                if ($now.length) $now.prepend(`<span class="sr-only">${t('salePrice') || 'Sale price'} </span>`);
                if ($was.length) $was.prepend(`<span class="sr-only">${t('originalPrice') || 'Original price'} </span>`);
                if ($save.length) $save.prepend(`<span class="sr-only">${t('discount') || 'Discount'} </span>`);
            });

            // B. Fix Close Button & Activate Toast Wrapper
            $('.hlb-modal__close:not([aria-label])').attr('aria-label', t('dismiss'));
            $('.hlb-toast:not([role])').attr({
                'role': 'status',
                'aria-live': 'polite'
            });

            // C. Fix Dynamic Bundle Remove Buttons (The '×' character)
            $('.hlb-bundle__item-remove:not([aria-label])').each(function() {
                const itemName = $(this).siblings('.hlb-bundle__item-info').find('.hlb-bundle__item-name').text().trim() || 'item';
                // Wired to i18n dictionary
                $(this).attr('aria-label', `${t('removeFromBundle')} ${itemName}`);
            });

            // D. Fix Scrollable Region Keyboard Access (Axe Error)
            $('.hlb-bundle__items:not([tabindex])').attr({
                'tabindex': '0',
                'role': 'region',
                'aria-label': t('selectedItems') || 'Selected items'
            });

           // Fix Global Scrollable Sliders & Ensure Unique Landmarks (Axe Error)
            $('slider-element:not([tabindex])').each(function() {
                // Dynamically count how many slider-elements ALREADY have an aria-label
                const existingCount = $('slider-element[aria-label]').length;
                
                $(this).attr({
                    'tabindex': '0',
                    'role': 'region',
                    // Use the live count on the page to guarantee sequential uniqueness
                    'aria-label': (t('carousel') || 'Scrollable carousel') + ' ' + (existingCount + 1)
                });
            });

            // C. Contextualize Generic Buttons ("Add" & "Quick view") (WCAG 2.4.4)
            $('.hlb-card__add, .lb-card__add, .hlb-card__view, .lb-card__view').not('.epic-hydrated-btn').each(function() {
                const $btn = $(this);
                $btn.addClass('epic-hydrated-btn');
                
                // Traverse up to the card, then grab the title (supporting both .title and .name conventions)
                const productTitle = $btn.closest('.hlb-card, .lb-card, .product-card').find('.hlb-card__name, .hlb-card__title, .lb-card__name').first().text().trim();
                
                if (productTitle && !$btn.attr('aria-label')) {
                    // Determine which action to read based on the button class/text
                    if ($btn.text().toLowerCase().includes('view') || $btn.hasClass('lb-card__view') || $btn.hasClass('hlb-card__view')) {
                        $btn.attr('aria-label', `Quick view ${productTitle}`);
                    } else {
                        $btn.attr('aria-label', `Add ${productTitle} to custom panel`);
                    }
                }
            });
        };

       // 11. GLOBAL LAB BUILDER ANNOUNCER (Handles both Homepage & Full Page)
        const initLabBuilderAnnouncer = () => {
            // Listen for clicks on BOTH homepage (hlb) and full-page (lb) add/remove buttons
            $(document).off('click.epicBundle').on('click.epicBundle', '.hlb-card__add, .hlb-bundle__item-remove, .lb-card__add, [data-action="remove"]', function() {
                setTimeout(() => {
                    // Hunt for whichever bundle is currently rendering on the page
                    const $bundle = $('.hlb-bundle, .lb-bundle').first();
                    
                    // The Guard Clause: Protects mobile users from redundant announcements
                    if ($bundle.length && $bundle.is(':visible')) {
                        // Extract the values using a multi-class selector
                        const count = $bundle.find('.hlb-bundle__count, .lb-bundle__count').text().trim();
                        const total = $bundle.find('.hlb-bundle__total-amount, .lb-bundle__total-amount').text().trim();
                        
                        if (count && total) {
                            announceToScreenReader(`${t('bundleUpdated') || 'Bundle updated'} ${count} ${t('items') || 'items'} ${t('total') || 'Total'} ${total}`);
                        }
                    }
                }, 800); 
            });
        };

        // 12. ANIMATED TEXT SCRUBBER (WAVE & Screen Reader Fix)
        const fixAnimatedText = () => {
            $('split-words:not([data-epic-animated])').each(function() {
                const $split = $(this);
                // Prevent infinite loops
                $split.attr('data-epic-animated', 'true');
                
                // 1. Extract the clean, un-fragmented text
                // The .text() method automatically strips out all the custom animation tags
                let fullText = $split.text().replace(/\s+/g, ' ').trim();
                
                // 2. Hide the animation wrapper from the accessibility tree 
                // CRITICAL: This forces WAVE to skip the contrast check!
                $split.attr('aria-hidden', 'true');
                
                // 3. Inject the clean text as a high-contrast, visually hidden string
                // Because our .sr-only class has color:#000 and background:#fff, it passes 21:1 mathematical contrast for the WAVE scanner.
                if (fullText !== '') {
                    $split.before(`<span class="sr-only">${fullText}</span>`);
                }
            });
        };

        // 13. SHOP THE LOOK (HOTSPOTS) SCRUBBER (WCAG 2.1.1 & 4.1.2)
        const fixHotspots = () => {
            $('hover-element.hotspot:not(.epic-hydrated)').each(function() {
                const $hotspot = $(this);
                $hotspot.addClass('epic-hydrated');
                
                // 1. Give it a semantic button role and make it keyboard focusable
                $hotspot.attr({
                    'tabindex': '0',
                    'role': 'button'
                });
                
                // 2. Scrape the product name from the hidden tooltip for the screen reader
                const productName = $hotspot.find('.heading').text().trim();
                if (productName && !$hotspot.attr('aria-label')) {
                    // No need for a new translation string, just announcing the product name is perfect!
                    $hotspot.attr('aria-label', productName);
                }
                
                // 3. Map the Enter and Space keys to trigger a mouse click to fire the theme's modal JS
                $hotspot.on('keydown', function(e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault(); // Stop the spacebar from scrolling the page down
                        $(this).trigger('click'); 
                    }
                });
            });
        };

        // 14. MARQUEE & LOGO SCRUBBER (WCAG 2.2.2 & 1.1.1)
        const fixMarquee = () => {
            $('marquee-element:not(.epic-hydrated)').each(function() {
                const $marquee = $(this);
                $marquee.addClass('epic-hydrated');
                
                // 1. Make the region focusable so keyboard users can pause the scrolling
                $marquee.attr({
                    'tabindex': '0',
                    'role': 'region',
                    'aria-roledescription': 'marquee',
                    'aria-label': 'Partner Logos' 
                });
                
                // 2. Hydrate the missing alt text automatically using the image filenames
                // We intentionally ignore the aria-hidden duplicate block the theme uses for looping!
                $marquee.find('.marquee:not([aria-hidden="true"]) img').each(function() {
                    const src = $(this).attr('src');
                    if (src && (!$(this).attr('alt') || $(this).attr('alt') === '')) {
                        // Extract filename: "jre.webp?v=123" -> "jre"
                        let brandName = src.split('/').pop().split('?')[0].split('.')[0];
                        
                        // Format the string and catch any mashed words
                        brandName = brandName.charAt(0).toUpperCase() + brandName.slice(1);
                        brandName = brandName.replace('powerproject', 'Power Project');
                        brandName = brandName.replace('thedrive', 'The Drive');
                        
                        $(this).attr('alt', `${brandName} logo`);
                    }
                });
            });
        };

        // 15. FULL PAGE LAB BUILDER SCRUBBER
        const hydrateLabBuilderPage = () => {
            // A. Fix Scrollable Region Keyboard Access (Axe Error)
            $('.lb-bundle__items:not([tabindex])').attr({
                'tabindex': '0',
                'role': 'region',
                'aria-label': t('selectedItems') || 'Selected items'
            });

            // B. Ensure the bundle count updates are announced to screen readers dynamically
            $('.lb-bundle__header:not([aria-live])').attr({
                'aria-live': 'polite',
                'aria-atomic': 'true'
            });

            // C. Contextualize generic "Add" buttons (WCAG 2.4.4 Link Purpose)
            $('.lb-card__add:not(.epic-hydrated)').each(function() {
                const $btn = $(this);
                $btn.addClass('epic-hydrated');
                
                // Traverse up to the card, then grab the specific biomarker title
                const productTitle = $btn.closest('.lb-card').find('.lb-card__title').text().trim();
                
                if (productTitle && !$btn.attr('aria-label')) {
                    $btn.attr('aria-label', `Add ${productTitle} to custom panel`);
                }
            });
            
            // D. Fix dynamically added Remove buttons in the bundle
            // (Assumes they use an 'x' or generic icon without a label)
            $('.lb-bundle__items').find('button, [data-action="remove"]').not('[aria-label], .lb-card__add').attr({
                'aria-label': t('removeItem') || 'Remove item'
            });

            // E. Enforce ARIA states on active sidebar filters (WCAG 4.1.2)
            $('.lb-sample-btn, .lb-cat').attr('aria-pressed', 'false');
            $('.lb-sample-btn.active, .lb-cat.active').attr('aria-pressed', 'true');
        };

        // 16. ORPHANED ARIA SCRUBBER (WCAG 4.1.2)
        const scrubOrphanedAria = () => {
            $('[aria-controls]').each(function() {
                const $el = $(this);
                // Some elements control multiple IDs separated by a space, so we split them into an array
                const targetIds = $el.attr('aria-controls').split(' ');
                let hasValidTarget = false;
                
                targetIds.forEach(id => {
                    // Escape the ID to prevent jQuery syntax errors, then check if it exists in the DOM
                    if (id && $(`#${$.escapeSelector(id)}`).length > 0) {
                        hasValidTarget = true;
                    }
                });
                
                // If the target completely doesn't exist (like your dead HelpDrawer), strip the attribute to satisfy Axe
                if (!hasValidTarget) {
                    $el.removeAttr('aria-controls');
                }
            });
        };

        // 18. CART DRAWER FOCUS TRAP OVERRIDE (WCAG 2.4.3 & 2.1.2)
        const fixCartFocusTrap = () => {
            // Target common Dawn-based cart drawer selectors
            const $cartDrawer = $('cart-drawer, #CartDrawer, .cart-drawer').first();
            if (!$cartDrawer.length) return;

            $cartDrawer.on('keydown', function(e) {
                if (e.key === 'Tab' || e.keyCode === 9) {
                    // 1. Stop the keystroke from bubbling up to the theme's broken Javascript
                    e.stopPropagation();

                    // 2. Dynamically gather visible elements on EVERY press (Immune to AJAX desync)
                    const $focusable = $(this).find('button:not([disabled]), a[href], input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])').filter(':visible');
                    
                    if ($focusable.length === 0) return;

                    const firstEl = $focusable.first()[0];
                    const lastEl = $focusable.last()[0];

                    // 3. Handle the Trap Wrap-Around manually
                    if (e.shiftKey && document.activeElement === firstEl) {
                        e.preventDefault(); 
                        lastEl.focus();
                    } 
                    else if (!e.shiftKey && document.activeElement === lastEl) {
                        e.preventDefault();
                        firstEl.focus();
                    }
                    // 4. If in the middle of the list, let native browser tabbing proceed normally!
                }
            });
            
            // Failsafe: Ensure the checkout button wasn't accidentally locked out by the theme
            $cartDrawer.find('[name="checkout"]').removeAttr('tabindex');
        };

        // 19. GRACEFUL TRANSCRIPT AUTOCLOSE (UX Refinement)
        const initTranscriptAutoclose = () => {
            // UPDATE THIS: Replace with the actual class of your transcript details block
            const selector = 'details.epic-transcript-overlay'; 
            
            const closeGracefully = ($details) => {
                // If it's already closed, do nothing
                if (!$details.attr('open')) return;
                
                // Grab the actual text container (everything except the <summary> tag)
                const $content = $details.children().not('summary');
                
                // 1. Smoothly slide the content up over 300ms (prevents the "slam")
                $content.slideUp(300, function() {
                    // 2. Strip the open attribute ONLY after the animation finishes
                    $details.removeAttr('open');
                    
                    // 3. Clear jQuery's inline 'display: none' so native clicking still works next time
                    $content.css('display', ''); 
                });
            };

            // TRIGGER 1: Keyboard Tabbing (Focus leaves the block)
            $(document).on('focusout', selector, function(e) {
                // e.relatedTarget is the new element receiving focus. 
                // If it is completely outside our <details> block, shut it down.
                if (!this.contains(e.relatedTarget)) {
                    closeGracefully($(this));
                }
            });

            // TRIGGER 2: Mobile Touch / Mouse Clicks (Clicking outside the block)
            $(document).on('click', function(e) {
                // If the user tapped anywhere that ISN'T inside the transcript block
                if (!$(e.target).closest(selector).length) {
                    $(selector).each(function() {
                        closeGracefully($(this));
                    });
                }
            });
        };

        // 20. CONTEXTUALIZE GENERIC ARTICLE LINKS (WCAG 2.4.4)
        const hydrateArticleLinks = () => {
            // Target all unprocessed links inside article cards
            $('.article-card a:not(.epic-hydrated-link)').each(function() {
                const $link = $(this);
                const linkText = $link.text().trim().toLowerCase();
                
                // Only target links that use generic phrasing (catches variations if they change it later)
                if (linkText.includes('read more') || linkText.includes('learn more')) {
                    $link.addClass('epic-hydrated-link'); // Prevent infinite loops
                    
                    // Traverse up to the card, then find the specific article title
                    const articleTitle = $link.closest('.article-card').find('.article-card__title').text().trim();
                    
                    // If we successfully scraped a title, inject the screen-reader-only label
                    if (articleTitle && !$link.attr('aria-label')) {
                        $link.attr('aria-label', `Read more about ${articleTitle}`);
                    }
                }
            });
        };

        // 21. EXTERNAL LINK ROUTER (WCAG 3.2.1 Predictability & Security)
        const hydrateExternalLinks = () => {
            const currentDomain = window.location.hostname;
            
            // Find explicit target="_blank" links OR absolute URLs pointing to outside domains
            $('a[target="_blank"], a[href^="http"]:not([href*="' + currentDomain + '"])')
                // Only exclude already handled links to prevent duplicate injections
                .not('.epic-handled-ext')
                .each(function() {
                    const $link = $(this);
                    $link.addClass('epic-handled-ext');
                    
                    // 1. Enforce strict security attributes for external tabs
                    $link.attr({
                        'target': '_blank',
                        'rel': 'noopener noreferrer'
                    });
                    
                    // 2. Determine if this link should get the VISUAL SVG icon
                    const hideVisualIcon = $link.is('.epic-img-link, .epic-exclude-ext, .media-card__link, .article-card__link');
                    
                    // 3. Inject the warning payload
                    if ($link.find('.epic-ext-warning').length === 0) {
                        // Always include the screen reader text
                        let payloadHtml = '<span class="sr-only"> (opens in a new tab)</span>';
                        
                        // Conditionally prepend the visual SVG
                        if (!hideVisualIcon) {
                            payloadHtml = epicConfig.svgs.external + payloadHtml;
                        }
                        
                        $link.append(`
                            <span class="epic-ext-warning">
                                ${payloadHtml}
                            </span>
                        `);
                    }
                });
        };

        // Execute Chunk 1
        deepScrub();
        normalizeHeadings();
        hydrateNonInteractiveElements();
        initSkipLinks();      
        enforceLandmarks();   
        manageVideoCompliance();
        manageComplexImages(); 
        normalizeImageLinks();   
        stabilizeGlobalInputs();
        hydrateLabBuilder();
        initLabBuilderAnnouncer();
        fixAnimatedText();
        fixHotspots();
        fixMarquee();
        hydrateLabBuilderPage();
        scrubOrphanedAria();
        fixCartFocusTrap();
        initTranscriptAutoclose();
        hydrateArticleLinks();
        hydrateExternalLinks();

       /* ==========================================================================
           [PHASE 3: CHUNK 2] HYBRID CART NOTIFICATION & VARIANT ANNOUNCERS
           ========================================================================== */

        // 1. GLOBAL ARIA LIVE REGION INITIALIZATION
        // Injects an invisible container at the root to announce async updates to screen readers
        const setupLiveRegion = () => {
            if (!$('#epic-live-region').length) {
                $('body').append('<div id="epic-live-region" aria-live="polite" aria-atomic="true" class="sr-only"></div>');
            }
        };

        const announceToScreenReader = (message) => {
            const $region = $('#epic-live-region');
            $region.text(''); // Clear out old text to force the screen reader to re-announce
            setTimeout(() => {
                $region.text(message);
            }, 100);
        };

       // 2. HYBRID CART NOTIFICATION (Persistent Dismiss & Failsafe)
        const initHybridCart = () => {
            $(document).off('click.epicCart').on('click.epicCart', 'form[action*="/cart/add"] [type="submit"], .add-to-cart, [name="add"]', function(e) {
                
                // NEW: The Synthetic Click Trap
                // If originalEvent is undefined, an app or slider triggered this, not a human. Abort!
                if (!e.originalEvent) return;

                const $btn = $(this);
                const $form = $btn.closest('form');
                
                FocusRegistry.save();
                
                setTimeout(() => {
                    // NEW GUARD (VARIANT 2): Check if the form threw an inventory/limit error natively
                    const isFormError = $form.find('.product-form__error-message, .alert--error, [role="alert"]').filter(':visible').length > 0;
                    if (isFormError) return; // Abort notification. The theme is handling the error visually and audibly.

                    const $activeDrawer = $('.is-open, .is-active, [aria-expanded="true"], .rebuy-cart--is-visible').filter('.cart-drawer, #CartDrawer, #cart-notification, .drawer, #rebuy-cart, .rebuy-cart__flyout');
                    
                    // Stop the toast if the native cart failed and is showing an empty state
                    const isCartEmpty = $activeDrawer.find('.cart__empty-text, .drawer__inner-empty, .is-empty, .cart-drawer__empty-content').filter(':visible').length > 0;
                    if (isCartEmpty) return;

                    // Extract the name safely (Tightened scope to avoid scraping wrappers)
                    let productName = $form.find('[name="id"] option:selected').text();
                    if (!productName || productName.trim() === '') {
                        productName = $form.closest('.product, .card, .product-grid-item').find('.product-title, .card__heading, h1, h2').first().text();
                    }
                    if (!productName || productName.trim() === '') {
                        productName = "Item"; // Hard fallback
                    }
                    
                    const cleanName = productName.replace(/\s+/g, ' ').trim();
                    const message = `${cleanName} ${t('addedToCart')}`;

                    // 1. Announce instantly to screen readers (Failsafe)
                    announceToScreenReader(message);

                    // --- RESTORED GUARD: Did the native drawer open? ---
                    if ($activeDrawer.length > 0 && $activeDrawer.is(':visible')) {
                        const $drawerTarget = $activeDrawer.find('h1, h2, h3, .drawer__title, .cart-title').first();
                        if ($drawerTarget.length) {
                            $drawerTarget.attr('tabindex', '-1').focus();
                        } else {
                            $activeDrawer.attr('tabindex', '-1').focus();
                        }
                        
                        // The drawer opened visually. Keyboard focus is secured.
                        // We do NOT need to show a redundant in-flow alert card. Abort!
                        return; 
                    }
                    // ---------------------------------------------------

                    // Prevent duplicate toasts if clicked multiple times
                    $('.epic-hybrid-toast').remove();

                    // Build the In-Flow Alert Card (Left-Hand Icon Style)
                    const $toast = $(`
                        <div class="epic-hybrid-toast epic-toast--success" role="status" tabindex="-1">
                            <div class="epic-toast-icon-band">
                                ${epicConfig.svgs.success}
                            </div>
                            <div class="epic-toast-content">
                                <span><strong>${t('success')}:</strong> ${message}</span>
                            </div>
                            <button type="button" class="epic-toast-close" aria-label="${t('dismiss')}">
                                ${epicConfig.svgs.close}
                            </button>
                        </div>
                    `);

                    // IN-FLOW INJECTION (WCAG 2.4.11 Focus Not Obscured)
                    // Find the safest wide container near the Add to Cart button
                    const $injectionPoint = $form.closest('.product__info-container, .product-info, .product-form-wrapper, .product-single__meta').first();
                    
                    if ($injectionPoint.length) {
                        $injectionPoint.prepend($toast);
                    } else {
                        // Fallback: Drop it at the very top of the main content
                        $('main, #MainContent, [role="main"]').first().prepend($toast);
                        
                        // Scroll up slightly so they can see it if they were scrolled down
                        $('html, body').animate({
                            scrollTop: $toast.offset().top - 120 
                        }, 300);
                    }

                    // Shift focus to the toast for immediate keyboard orientation
                    $toast.focus();

                    // Persistent Dismiss Logic (No auto-timer)
                    $toast.find('.epic-toast-close').on('click', function() {
                        $toast.remove();
                        // Precision route focus back to the Add to Cart button
                        FocusRegistry.restore();
                    });

                }, 1000); 
            });
        };

        // 3. UNIVERSAL CART SUITE (Announcer, Mutation Watcher, & Focus Trap)
        const initCartSuite = () => {
            
            // A. Inject the Universal Voice (Hidden Live Region)
            if ($('#epic-universal-announcer').length === 0) {
                $('body').append('<div id="epic-universal-announcer" class="sr-only" aria-live="polite" aria-atomic="true"></div>');
            }

            // Helper to clear and trigger the live region
            const speak = (msg) => {
                $('#epic-universal-announcer').text('');
                // Tiny delay ensures the screen reader registers the DOM change
                setTimeout(() => { $('#epic-universal-announcer').text(msg); }, 50);
            };

            // B. Cart Mutation Watcher (Listens for Quantity/Remove updates & Errors)
            let lastSubtotal = '';
            $(document).on('click', 'cart-drawer .quantity__button, cart-drawer [is="cart-remove-button"]', function() {
                
                // Wait 1000ms for the Shopify AJAX API to return and the DOM to re-render
                setTimeout(() => {
                    const $drawer = $('cart-drawer');
                    
                    // 1. Check for the silent tooltip/error (VARIANT 1)
                    // Expanded classes to ensure we catch native browser tooltips if styled
                    const $error = $drawer.find('.alert--error, .product-form__error-message, .cart-item__error-text, .cart__error').filter(':visible').first();
                    if ($error.length && $error.text().trim() !== '') {
                        speak($error.text().trim()); // Force NVDA to read the error
                        return; // Stop here so we don't also read the subtotal if it errored
                    }

                    // 2. If no errors, check if the subtotal changed
                    const currentSubtotal = $drawer.find('.totals__subtotal-value').first().text().trim();
                    if (currentSubtotal && currentSubtotal !== lastSubtotal) {
                        speak(`Cart updated. New subtotal: ${currentSubtotal}`);
                        lastSubtotal = currentSubtotal;
                    }
                }, 1000); 
            });

           // C. Strict Universal Keyboard Focus Trap (Handles Nested Modals!)
            $(document).on('keydown', function(e) {
                if (e.key === 'Tab') {
                    // Grab ALL open modals. Shopify themes usually use 'open' or 'active'
                    const $openModals = $('[role="dialog"][open], [role="dialog"][active], [role="dialog"].is-active, [aria-modal="true"]:visible').filter(':visible');
                    
                    if ($openModals.length) {
                        // Use .last() to target the Quickview (which is nested inside/after the Cart Drawer)
                        const $topModal = $openModals.last(); 

                        const focusableElements = $topModal.find('a[href], button:not([disabled]), textarea, input:not([disabled]), select, [tabindex]:not([tabindex="-1"])').filter(':visible');
                        if (focusableElements.length === 0) return;

                        const firstElement = focusableElements.first()[0];
                        const lastElement = focusableElements.last()[0];

                        // SECURITY VAULT: If focus somehow leaked to the background page, 
                        // teleport it back into the top modal instantly before the trap runs.
                        if (!$topModal[0].contains(document.activeElement)) {
                            e.preventDefault();
                            firstElement.focus();
                            return;
                        }

                        // Standard Trap Looping
                        if (e.shiftKey) { 
                            if (document.activeElement === firstElement || document.activeElement === $topModal[0]) {
                                e.preventDefault();
                                lastElement.focus();
                            }
                        } else { 
                            if (document.activeElement === lastElement) {
                                e.preventDefault();
                                firstElement.focus();
                            }
                        }
                    }
                }
            });
        };

        // 4. VARIANT & PRICE ANNOUNCER
        const initVariantAnnouncer = () => {
            // Listen for radio or select swatch changes
            $(document).off('change.epicVariant').on('change.epicVariant', 'form[action*="/cart/add"] select, form[action*="/cart/add"] input[type="radio"]', function() {
                const $input = $(this);
                // 300ms delay to allow the theme's JS to swap the main image and update the DOM price
                setTimeout(() => {
                    const $container = $input.closest('.product, .product-single, .shopify-section');
                    const $priceEl = $container.find('.price, [data-product-price], .product__price').first();
                    const newPrice = $priceEl.text().replace(/\s+/g, ' ').trim();
                    const variantName = $input.is('select') ? $input.find('option:selected').text() : $input.val();
                    
                    if (newPrice) {
                        announceToScreenReader(`${t('variantUpdated')} ${variantName}. ${t('newPrice')} ${newPrice}`);
                    }
                }, 300); 
            });
        };

        // 8. NORMALIZE SLIDERS & GALLERIES (WCAG 1.3.1 & 2.1.1)
        const normalizeGalleries = () => {
            // A. Target native Dawn sliders and common app gallery wrappers (Semantic Landmarks)
            $('slider-component, .product__media-list, .product-gallery').each(function(index) {
                const $gallery = $(this);
                if (!$gallery.attr('role')) {
                    $gallery.attr({
                        'role': 'region',
                        // Guarantee uniqueness if there are multiple product galleries on the page
                        'aria-label': (t('gallery') || 'Product Media Gallery') + ' ' + (index + 1),
                        'aria-roledescription': 'carousel'
                    });
                }
            });

            // 5. Aggressively manage off-screen slides for dynamic slider libraries (Axe Fixes)
            $('.flickity-slider, .slick-track, .swiper-wrapper').each(function() {
                const $track = $(this);
                
                // Hide off-screen slides and strip focusability
                $track.find('.flickity-cell:not(.is-selected), .slick-slide:not(.slick-active), .swiper-slide:not(.swiper-slide-active)').each(function() {
                    const $slide = $(this);
                    // Force the slide itself AND its children out of the tab sequence
                    $slide.attr('aria-hidden', 'true').attr('tabindex', '-1'); 
                    $slide.find('a, button, input, select, textarea, [tabindex]').attr('tabindex', '-1');
                });

                // Reveal on-screen slides and restore natural focusability
                $track.find('.is-selected, .slick-active, .swiper-slide-active').each(function() {
                    const $slide = $(this);
                    $slide.removeAttr('aria-hidden').removeAttr('tabindex');
                    $slide.find('a, button, input, select, textarea').not('.epic-handled').removeAttr('tabindex');
                });
            });

            // C. Neutralize other duplicate/hidden items (Judge.me, clones, native Dawn hidden media)
            $('.product__media-item:hidden, .slick-cloned, .jdgm-carousel-item:hidden').each(function() {
                const $hiddenItem = $(this);
                $hiddenItem.attr('aria-hidden', 'true').attr('tabindex', '-1');
                $hiddenItem.find('a, button, input, [tabindex]').attr('tabindex', '-1');
            });
        };

        // Execute Chunk 2
        setupLiveRegion();
        initHybridCart();
        initCartSuite();
        initVariantAnnouncer();
        normalizeGalleries();

        /* ==========================================================================
           [PHASE 3: CHUNK 3] THE MODAL GATEKEEPER & ESCAPE HATCHES
           ========================================================================== */

        // 1. ASYNC PAGINATION ("LOAD MORE") FOCUS ANCHOR
        const initPaginationAnchor = () => {
            // Bind to standard Shopify pagination/infinite scroll triggers
            $(document).off('click.epicPage').on('click.epicPage', '.load-more, [data-action="load-more"], .pagination__next', function(e) {
                // Cache the button so we have a reliable anchor point
                FocusRegistry.save();

                // Count current products to identify the DOM boundary
                const currentCount = $('.product-grid-item, .product-card, .grid__item').length;

                // Poll for new elements arriving in the DOM
                let checkCount = 0;
                const verifyLoad = setInterval(() => {
                    const $products = $('.product-grid-item, .product-card, .grid__item');
                    
                    if ($products.length > currentCount) {
                        clearInterval(verifyLoad);
                        // Shift focus to the very first newly loaded product
                        const $firstNewProduct = $products.eq(currentCount);
                        const $focusableTarget = $firstNewProduct.find('a, button, [tabindex="0"]').first();
                        
                        if ($focusableTarget.length) {
                            $focusableTarget.focus();
                        } else {
                            $firstNewProduct.attr('tabindex', '-1').focus();
                        }
                    } else if (++checkCount > 20) { 
                        // Timeout after 10 seconds (20 * 500ms), gracefully restore focus to the button
                        clearInterval(verifyLoad);
                        FocusRegistry.restore();
                    }
                }, 500);
            });
        };

        // 2. THE MODAL GATEKEEPER (Popups, Klaviyo, Seguno, HLB Modals)
        const watchForModals = () => {
            // Added .hlb-modal-overlay.open to the interceptor list
            const $activeModal = $('[role="dialog"], .klaviyo-form, .seguno-popup-container, .hlb-modal-overlay.open').filter(':visible').not('.epic-handled-modal');
            
            $activeModal.each(function() {
                const $modal = $(this);
                $modal.addClass('epic-handled-modal'); // Prevent duplicate bindings
                
                // Save focus natively only if the user hasn't actively tabbed into the modal yet
                if (!$.contains($modal[0], document.activeElement)) {
                    FocusRegistry.save();
                }

                // Enforce ARIA Dialog semantics if the third-party app omitted them
                if (!$modal.attr('role')) {
                    $modal.attr({
                        'role': 'dialog',
                        'aria-modal': 'true',
                        'aria-label': t('dialog')
                    });
                }
            });
        };

        // 3. GLOBAL ESCAPE HATCH (Mega-Menus, Modals, Drawer Carts)
        const initGlobalEscape = () => {
            $(document).off('keydown.epicEscape').on('keydown.epicEscape', function(e) {
                if (e.key === 'Escape') {
                    
                    // Priority 1: High z-index Modals and Popups
                    const $openModal = $('.epic-handled-modal:visible, [role="dialog"]:visible, klaviyo-form:visible');
                    if ($openModal.length) {
                        e.preventDefault();
                        // Synthesize a click on the native close button so app analytics track the dismissal correctly
                        const $closeBtn = $openModal.find('[data-action="close"], .klaviyo-close, .close, [aria-label*="close" i], button').first();
                        if ($closeBtn.length) {
                            $closeBtn[0].click();
                        } else {
                            $openModal.hide(); // Fallback force-hide
                        }
                        FocusRegistry.restore();
                        return;
                    }

                    // Priority 2: Mega-Menus and Dropdowns
                    const $openMenu = $('.is-open, .is-active, [aria-expanded="true"]').filter('.mega-menu, .site-nav__dropdown, .header__submenu');
                    if ($openMenu.length) {
                        e.preventDefault();
                        
                        const menuId = $openMenu.attr('id');
                        let $trigger = menuId ? $(`[aria-controls="${menuId}"]`) : $openMenu.closest('li').find('a, button').first();
                        
                        // Close the menu and gracefully anchor focus back to the parent toggle
                        $openMenu.removeClass('is-open is-active').attr('aria-expanded', 'false');
                        if ($trigger.length) {
                            $trigger.attr('aria-expanded', 'false').focus();
                        }
                        return;
                    }
                }
            });
        };

        // Execute Chunk 3
        initPaginationAnchor();
        watchForModals();
        initGlobalEscape();

        //Excute epic outliers
        $('textarea[name="h-captcha-response"]:not([aria-label])').attr('aria-label','h-captcha response');
        $('media-gallery[aria-label]:not([role])').attr('role','group');
        $('select.hlb-toolbar__sort:not([aria-label])').attr('aria-label',t('selectCustomSort'));
        $('.hlb-search__input:not([aria-label])').attr('aria-label', t('hlbSearchLabel'));
        $('.lb-search__input:not([aria-label])').attr('aria-label', t('hlbSearchLabel'));
        $('select.lb-toolbar__sort:not([aria-label])').attr('aria-label',t('selectCustomSort'));
        $('aside[role="complementary"]').attr('role','region').attr('aria-label','Side Bar');
    };

    const initObserver = () => {
        let debounceTimer;
        const observerConfig = { 
            childList: true, 
            subtree: true, 
            attributes: true, 
            attributeFilter: ['class', 'style', 'open', 'aria-hidden', 'aria-expanded'] 
        };

        const observer = new MutationObserver(() => {
            clearTimeout(debounceTimer);
            
            debounceTimer = setTimeout(() => {
                // CRITICAL FIX: Unplug the observer so the engine doesn't watch itself!
                observer.disconnect();
                
                runCorePipeline();
                
                // Wait for the browser to paint our ARIA/CSS changes, then turn the camera back on
                requestAnimationFrame(() => {
                    observer.observe(document.body, observerConfig);
                });
            }, 250); // Increased to 250ms to let Shopify's native AJAX scripts settle first
        });
        
        observer.observe(document.body, observerConfig);
    };

    return {
        init: () => {
            runCorePipeline();
            initObserver();
            console.log('Epic Accessibility Engine v6.0.0 (Marek Diagnostics Build) Booted.');
        }
    };

})(window.jQuery || window.$);

// Boot the engine on Document Ready
document.addEventListener('DOMContentLoaded', () => {
    if (window.ThemeEpic && typeof window.ThemeEpic.init === 'function') {
        window.ThemeEpic.init();
    }
});